/**
 * Provide IAC jumps with individual data for forms.
 * Original ticket: https://jira.mam.dev/browse/CU-4718
 */
;(() => {
  // Check whether to do something.
  // `nx.iac` only exists in the navigator context, which requires the form submit to be overridden by
  // other actions in order to stay in the logged in state in the navigator.
  if (!window.nx?.iac) { return }

  // Select all form submit buttons.
  const buttons = document.querySelectorAll('form button[type="submit"]')

  // Run through the buttons and add the dynamic function.
  buttons.forEach((button) => {
    // Determine dynamic data.
    const mc = window.utag_data.mediaCode
    const gotoFeature = button.dataset.iacGotoFeature
    const path = button.dataset.iacPath
    const paramName = button.dataset.iacParamName || 'domain_name'
    const paramId = button.dataset.iacParamId || 'domain_name'

    // Add event listener.
    if (gotoFeature && path) {
      button.addEventListener('click', function (event) {
        event.preventDefault()
        nx.iac.Client.openGotoFeature({
          goto_feature: gotoFeature,
          data: btoa(`path=${path}&mc=${mc}&${paramName}=${encodeURIComponent(document.getElementById(paramId)?.value)}`)
        })
        return false
      })
    }
  })
})();
